export default __webpack_public_path__ + "static/media/AutositzschonbezugTOPTEX.f338a239.jpg";